import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RightbarState {
  infoPanelVisible: boolean;
  infoType: string;
  record: any | null;
}

const initialState: RightbarState = {
  infoPanelVisible: false,
  infoType: "info",
  record: null,
};

const rightbarSlice = createSlice({
  name: "rightbar",
  initialState,
  reducers: {
    openInfoPanel(state, action: PayloadAction<{ record?: any; infoType?: string }>) {
      state.infoPanelVisible = true;
      state.record = action.payload?.record ?? null;
      state.infoType = action.payload?.infoType ?? "info";
    },
    // Close panel but keep record/infoType so reopening can show same item
    closeInfoPanel(state) {
      state.infoPanelVisible = false;
    },
    setInfoRecord(state, action: PayloadAction<any | null>) {
      state.record = action.payload;
    },
    setInfoType(state, action: PayloadAction<string>) {
      state.infoType = action.payload;
    },
    toggleInfoPanel(state) {
      state.infoPanelVisible = !state.infoPanelVisible;
    },
  },
});

export const rightbarActions = rightbarSlice.actions;
export default rightbarSlice.reducer;
